

























import { defineComponent, reactive, computed } from '@vue/composition-api';
import { D, E } from '../../helpers/dom';


const componentName = 'entry-image';

export default defineComponent({
    props: {
        name:                   {type: String},
        path:                   {type: Function, default: (v) => v},
        size:                   {type: String},
        variant:                {type: String},
        label:                  {type: String},
        userdata:               {type: Object},
        format:                 {type: String, default: 'backoffice'},
        downloadFormat:         {type: String, default: 'origin'},
        readonly:               {type: Boolean, default: false},
        locked:                 {type: Boolean, default: false},
        mandatory:              {type: Boolean, default: false},
        buttonAddLabel:         {type: String, default: 'Add image'},
        buttonDownloadLabel:    {type: String, default: 'Download'},
        buttonRemoveLabel:      {type: String, default: 'Remove'},
    },
    name: componentName,

    setup(props, context) {

        const state = reactive({
            valid: false,
            showErrors: false
        });

        const getImagePath = (format?: string) => {
            let path = <string>props.path(props.userdata);
            if (path && format) {
                return `${path}/${format}`;
            }
            return path;
        }

        // Generated properties

        const isReadonly = computed(() => {
            return props.readonly || props.locked /* || this.$form.readonly */;
        });

        const cellClassName = computed(() => {
            let c = "c-entry-image";
            if (props.size) {
                c += ` c-entry-image--${props.size}`;
            }
            return c;
        });

        const entryClassName = computed(() => {
            let d: any = {
                "entry-image": true,
                "mandatory": props.mandatory,
                "readonly": isReadonly.value,
                "locked": props.locked,
                "error": state.showErrors && !state.valid
            };
            if (props.variant) {
                d['entry-image--' + props.variant] = true;
            }
            return d;
        });

        const entryId = computed(() => {
            return props.name;
        });

        const hasSrc = computed(() => {
            return !!getImagePath();
        });

        const srcPreview = computed(() => {
            return getImagePath(props.format);
        });

        const srcDownload = computed(() => {
            return getImagePath(props.downloadFormat);
        });

        // Validation

        const validate = (forceEmit = false) => {
            let oldValid = state.valid;

            state.valid = !props.mandatory || hasSrc.value;

            if (!isReadonly.value && (forceEmit || oldValid !== state.valid)) {
                context.emit("valid-change", { target: this, name: props.name, value: state.valid });
            }
        }

        const onImageChange = (evt: Event) => {
            if (evt.target instanceof HTMLInputElement) {
                let file = evt.target.files && evt.target.files[0];
                if (file) {
                    context.emit('upload', { file, userdata: props.userdata });
                }
            }
        }

        const onRemoveClick = () => {
            if (props.path) {
                context.emit('remove', { path: getImagePath(), userdata: props.userdata });
            }
        }

        // on created:
        validate(true);

        return {
            state,
            getImagePath,
            isReadonly,
            cellClassName,
            entryClassName,
            entryId,
            hasSrc,
            srcPreview,
            srcDownload,
            validate,
            onImageChange,
            onRemoveClick
        }
    }
})
